export enum UserFunctionCode{
  GENERATE_PRINT_EMAIL_REPORT='GENERATE_PRINT_EMAIL_REPORT',
  CREATE_REMITO='CREATE_REMITO',
  MODIFY_REMITO='MODIFY_REMITO',
  APPROVE_REMITO='APPROVE_REMITO',
  CANCEL_REMITO='CANCEL_REMITO',
  PRINT_REMITO='PRINT_REMITO',
  EMAIL_REMITO='EMAIL_REMITO',
  CREATE_UPDATE_USER_ASSIGN_ROLE='CREATE_UPDATE_USER_ASSIGN_ROLE',
  MAINTENANCE='MAINTENANCE',
  CREATE_CAI='CREATE_CAI',
  MGO_REPROCESS='MGO_REPROCESS',
  VEHICLE_ROLES='VEHICLE_ROLES',
  OTDS_REPROCESS='OTDS_REPROCESS',
}



